import styled from "styled-components";

const FOOTER_BLUR_WIDTH = 720;
const FOOTER_BLUR_HEIGHT = 294;
const FOOTER_BLUR_RADIUS = 500;
const FOOTER_BLUR_FILTER = "blur(15px)";
const FOOTER_BLUR_BOTTOM_OFFSET = "-210px";
const FOOTER_BLUR_EXTRA_WIDTH = 120;

export const FooterWrapper = styled.div<{ isTransactionBtnV2?: boolean }>(({ theme, isTransactionBtnV2 }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.medium,
    width: "100%",
    background: isTransactionBtnV2
        ? "transparent"
        : `linear-gradient(to bottom, transparent, ${theme.colors[theme.colorMode].background_Primary})`,
    position: "fixed",
    bottom: 0,
    left: 0,
    paddingBottom: theme.spacing.large,
    zIndex: theme.elevation[theme.colorMode].raised.zIndex,

    "@supports (padding-bottom: var(--sab))": {
        paddingBottom: `calc(${theme.spacing.large} + var(--sab, 0px))`,
    },
}));

export const FooterBlur = styled.div(({ theme }) => ({
    position: "absolute",
    left: "50%",
    bottom: `calc(${FOOTER_BLUR_BOTTOM_OFFSET} + var(--sab, 0px))`,
    transform: "translateX(-50%)",
    width: `min(${FOOTER_BLUR_WIDTH}px, calc(100vw + ${FOOTER_BLUR_EXTRA_WIDTH}px))`,
    height: FOOTER_BLUR_HEIGHT,
    borderRadius: FOOTER_BLUR_RADIUS,
    background: theme.colors[theme.colorMode].background_Primary,
    filter: FOOTER_BLUR_FILTER,
    pointerEvents: "none",
    zIndex: theme.elevation[theme.colorMode].none.zIndex,
}));

export const FooterContent = styled.div(({ theme }) => ({
    position: "relative",
    zIndex: theme.elevation[theme.colorMode].skim.zIndex,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.medium,
    width: "100%",
}));
